// setUserSession(token, { email, portail_id, premier, security, accountId: account_id, name: res.data[0].Name } );
export const userAction = (data) => async dispatch => {
   
        dispatch( {
            type: "USER_SESSION",
            payload: data
        })
}